import "core-js/modules/es.array.reverse.js";
var _class, _CartoMapV1CatalogItem;
import "core-js/modules/web.dom-collections.iterator.js";
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { computed, runInAction, makeObservable, override } from "mobx";
import Resource from "terriajs-cesium/Source/Core/Resource";
import UrlTemplateImageryProvider from "terriajs-cesium/Source/Scene/UrlTemplateImageryProvider";
import isDefined from "../../../Core/isDefined";
import TerriaError from "../../../Core/TerriaError";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import MappableMixin from "../../../ModelMixins/MappableMixin";
import UrlMixin from "../../../ModelMixins/UrlMixin";
import CartoMapV1CatalogItemTraits from "../../../Traits/TraitsClasses/CartoMapV1CatalogItemTraits";
import CreateModel from "../../Definition/CreateModel";
import LoadableStratum from "../../Definition/LoadableStratum";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";
import StratumOrder from "../../Definition/StratumOrder";
export class CartoLoadableStratum extends LoadableStratum(CartoMapV1CatalogItemTraits) {
  constructor(catalogItem, tileUrl, tileSubdomains) {
    super();
    this.catalogItem = catalogItem;
    this.tileUrl = tileUrl;
    this.tileSubdomains = tileSubdomains;
  }
  duplicateLoadableStratum(newModel) {
    return new CartoLoadableStratum(newModel, this.tileUrl, this.tileSubdomains);
  }
  static load(catalogItem) {
    const queryParameters = {};
    if (catalogItem.auth_token) {
      queryParameters.auth_token = catalogItem.auth_token;
    }
    if (catalogItem.url === undefined) {
      return Promise.reject(new TerriaError({
        title: "Unable to load Carto Map layer",
        message: "The Carto Map layer cannot be loaded the catalog item does not have a `url`."
      }));
    }
    const resource = new Resource({
      url: catalogItem.url,
      headers: {
        "Content-Type": "application/json"
      },
      queryParameters: queryParameters
    });
    return Promise.resolve().then(() => {
      return resource.post(JSON.stringify(catalogItem.config || {}));
    }).then(response => {
      if (response === undefined) {
        throw new TerriaError({
          sender: this,
          title: "Could not load Carto Map layer",
          message: "There was an error loading the data for this catalog item."
        });
      }
      const map = JSON.parse(response);
      let url;
      let subdomains;
      const metadataUrl = map.metadata && map.metadata.url && map.metadata.url.raster;
      if (metadataUrl) {
        url = metadataUrl.urlTemplate;
        subdomains = metadataUrl.subdomains;
      } else {
        throw new TerriaError({
          sender: this,
          title: "No URL",
          message: "Unable to find a usable URL for the Carto Map layer."
        });
      }
      const stratum = new CartoLoadableStratum(catalogItem, url, subdomains);
      return stratum;
    });
  }
}
_defineProperty(CartoLoadableStratum, "stratumName", "cartoLoadable");
StratumOrder.addLoadStratum(CartoLoadableStratum.stratumName);
let CartoMapV1CatalogItem = (_class = (_CartoMapV1CatalogItem = class CartoMapV1CatalogItem extends MappableMixin(UrlMixin(CatalogMemberMixin(CreateModel(CartoMapV1CatalogItemTraits)))) {
  constructor() {
    super(...arguments);
    makeObservable(this);
  }
  get type() {
    return CartoMapV1CatalogItem.type;
  }
  get mapItems() {
    if (isDefined(this.imageryProvider)) {
      return [{
        alpha: this.opacity,
        show: this.show,
        imageryProvider: this.imageryProvider,
        clippingRectangle: this.clipToRectangle ? this.cesiumRectangle : undefined
      }];
    }
    return [];
  }
  forceLoadMapItems() {
    return CartoLoadableStratum.load(this).then(stratum => {
      runInAction(() => {
        this.strata.set(CartoLoadableStratum.stratumName, stratum);
      });
    });
  }
  get cacheDuration() {
    if (isDefined(super.cacheDuration)) {
      return super.cacheDuration;
    }
    return "1d";
  }
  get imageryProvider() {
    var _this$maximumLevel, _this$minimumLevel;
    const stratum = this.strata.get(CartoLoadableStratum.stratumName);
    if (!isDefined(stratum) || !isDefined(stratum.tileUrl)) {
      return;
    }
    let subdomains;
    if (isDefined(stratum.tileSubdomains)) {
      subdomains = stratum.tileSubdomains.slice();
    }
    return new UrlTemplateImageryProvider({
      url: proxyCatalogItemUrl(this, stratum.tileUrl),
      maximumLevel: (_this$maximumLevel = this.maximumLevel) !== null && _this$maximumLevel !== void 0 ? _this$maximumLevel : 25,
      minimumLevel: (_this$minimumLevel = this.minimumLevel) !== null && _this$minimumLevel !== void 0 ? _this$minimumLevel : 0,
      credit: this.attribution,
      subdomains: subdomains,
      tileHeight: this.tileHeight,
      tileWidth: this.tileWidth
    });
  }
}, _defineProperty(_CartoMapV1CatalogItem, "type", "carto"), _CartoMapV1CatalogItem), _applyDecoratedDescriptor(_class.prototype, "mapItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "mapItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cacheDuration", [override], Object.getOwnPropertyDescriptor(_class.prototype, "cacheDuration"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "imageryProvider", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "imageryProvider"), _class.prototype), _class);
export { CartoMapV1CatalogItem as default };